import { Router } from '@vaadin/router';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import * as util from 'lib/util.js'

class KbTopicInfinite extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.topicNodes=[]
        this.state = storeInstance.state
        this.string = this.state.strings;
        this.myRender()
    }
    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
    }

    loadTopic(node){
        if(this.isTopicLoaded(node)){
            var idx = this.getTopicIdx(node);
            //scrollToTopic
        } else {
            node.insertMethod = "replace";
            this.getTopicHtmlBody(node,this.htmlReady.bind(this, node));
        }
    }

    isTopicLoaded(node){
        for(var i=0; i< this.topicNodes.length; i++){
            if(this.topicNodes[i].href==node.href){
                return true;
            }
        }
    }
    getTopicIdx(node){
        var retval = null;
        for(var i=0; i< this.topicNodes.length; i++){
            if(this.topicNodes[i].href==node.href){
                retval = i;
            }
        }
        return retval;
    }

    

    getTopicHtmlBody(node, callback){
        PubSub.publish("requestout",null);
        fetch(this.state.kb_rest_server + "/kb/jrest/getHtmlBody?kbrid=" + node.href)
        .then(function(response) {
            if (!response.ok) {
                httpError(response, storeInstance);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            return response.text()
        })
        .then((data) => {
            callback(data);
        })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            })
            
        }    
    
    htmlReady(node, topicHtml){
        node.element = document.createElement("span")
        node.element.innerHTML = topicHtml;
        this._attacheClickBehavior(node.element);
        this._updateResourceSrc(node.element);
        this.topicNodes.push(node);
        switch(node.insertMethod){
            case "replace":
                this.topicContainer.innerHTML = '';
                this.topicContainer.appendChild(node.element);
                console.log("first topic added")
                break;
        }
    }

    
    myRender(){
        render(this.topicTemplate(), this.shadowRoot);
        this.topicContainer = this.shadowRoot.querySelector("#topic");
        }

    _launchPdf(e){
        e.preventDefault();
        window.location.href=e.currentTarget.href;
        }
     
    _attacheClickBehavior(domDoc){
        var aLinks = domDoc.querySelectorAll("a")
        aLinks.forEach(function(link){
            var linkType = null;
            var hrefValue = link.getAttribute("href")
            if(hrefValue.substr(0,1)=="#"){
            linkType='fragment'
            } else {
                if(hrefValue.substr(0,10).toLowerCase()=="http:///kb"){
                    linkType='crossLink';
                } else {
                switch(hrefValue.substr(0,3).toLowerCase()){
                    case "xdx":
                        linkType='KbRid'
                        break
                    case "xdb":
                        linkType='resource'
                        break
                    case "/co":
                        linkType='resource'
                        break
                    case "/sy":
                        if(hrefValue.toLowerCase()=='/sysc'){
                            linkType='resource'
                        } else {
                            linkType='resource'
                        }
                        break;
                    default:
                        linkType='external'
                        }
                }
            }
            var att = document.createAttribute("linktype"); 
            att.value = linkType;
            link.setAttributeNode(att);   
            
            if(linkType=="fragment"){
            link.addEventListener('click', this._fragmentLinkClicked.bind(this))  
            } 
            
            if(linkType=="crossLink"){
                link.addEventListener('click', this._topicLinkClicked.bind(this))  
                var att2 = document.createAttribute("crossLink"); 
                att2.value = link.getAttribute("href").replace("http:///","/");
                link.setAttributeNode(att2);  
            }

            if(linkType=="KbRid"){
            link.addEventListener('click', this._topicLinkClicked.bind(this))  
            var att2 = document.createAttribute("kbrid"); 
            att2.value = link.getAttribute("href");
            link.setAttributeNode(att2);   
            }
            
            // just an idea to provide new window functionality
                var parsedPageUrl = new URL(window.location.href);
                var newTabUrl =null;
                var createIcon =false;
                switch(linkType){
                case "KbRid":
                    newTabUrl = parsedPageUrl.origin + '/kb/'+ this.state.langCode + '/' + hrefValue;
                    createIcon=true;
                    break;
                    case "external":
                    newTabUrl = hrefValue;
                    createIcon=true;
                    break;
                    default:
                        //need test content for  resource type
                        break;
                }
                if(createIcon){
                    var newTabLink = document.createElement("A") 
                    newTabLink.href=newTabUrl
                    newTabLink.target="_blank"
                    newTabLink.class="newtablink"
                    var domLink = link.insertAdjacentElement('afterend', newTabLink);
                    var newTabIcon = document.createElement("iron-icon")
                    newTabIcon.icon="vaadin:external-link";
                    var att3 = document.createAttribute("class"); 
                    att3.value = "launchIcon";
                    newTabIcon.setAttributeNode(att3);   
                    var addedIcon = domLink.appendChild(newTabIcon)  
                }
            }.bind(this));
            }

    _updateResourceSrc(domDoc){
        var aImages = domDoc.querySelectorAll("img")
        aImages.forEach(function(img){
            var aSrc = img.src.split("/")
            if(aSrc.length>0){
                var srcAddress = aSrc[aSrc.length-1]
                var srcType= null
                switch(srcAddress.substr(0,3).toLowerCase()){
                    case "htt":
                    srcType='external';
                    case "xdb":
                    srcType='resource';
                    break;
                    case "/co":
                    srcType='resource';
                    break;
                    case "/sy":
                    srcType='resource';
                    break;
                    }
                    if(srcType='resource'){
                    img.src="/kb/jrest/getResource?kbrid=" + srcAddress
                    }
                }
        }.bind(this));
        
        var aVideo = domDoc.querySelectorAll("object")
            aVideo.forEach(function(obj){
                var aSrc = obj.data.split("/")
                if(aSrc.length>0){
                var srcAddress = aSrc[aSrc.length-1]
                var srcType= null
                switch(srcAddress.substr(0,3).toLowerCase()){
                    case "htt":
                        srcType='external';
                    case "xdb":
                        srcType='resource';
                        break;
                    case "/co":
                        srcType='resource';
                        break;
                    case "/sy":
                        srcType='resource';
                        break;
                    }
                    if(srcType='resource'){
                        obj.data="/kb/jrest/getResource?kbrid=" + srcAddress 
                    }
                }
                var param = obj.querySelector("param[name='src']");
                if(param){
                    switch(param.value.toLowerCase()){
                    case "htt":
                        srcType='external';
                    case "xdb":
                        srcType='resource';
                        break;
                    case "/co":
                        srcType='resource';
                        break;
                    case "/sy":
                        srcType='resource';
                        break;
                    }
                    if(srcType='resource'){
                        param.value="/kb/jrest/getResource?kbrid=" + srcAddress 
                    }
                }

            }.bind(this));

        }



    _topicLinkClicked(e){
        e.preventDefault()
        switch(e.currentTarget.getAttribute("linktype")){
            case "KbRid":
                this.dispatchEvent(new CustomEvent('topicLinkClicked', {
                    bubbles: true,
                    composed: true,
                    detail: e.currentTarget.getAttribute("href")
                    }));
               break;
            case "crossLink":
                this.dispatchEvent(new CustomEvent('crossLinkClicked', {
                    bubbles: true,
                    composed: true,
                    detail: e.currentTarget.getAttribute("href")
                    }));
               break;
            case "external":
                //good place for a kbproperty
                document.location = e.currentTarget.getAttribute(href);
                break;
        }
    }

    _fragmentLinkClicked(e){
        e.preventDefault()
        var fragmentId = e.currentTarget.getAttribute("href");
        if(fragmentId){
          var targetFragmentElement = this.shadowRoot.querySelector(fragmentId);
          if(targetFragmentElement){
            var tteRec = targetFragmentElement.getBoundingClientRect();
            this.dispatchEvent(new CustomEvent('scrollHelpsetBy', {
                bubbles: true,
                composed: true,
                detail: tteRec.top -   this.state.global_screen_specs.headerHeight
                }));
          }
        }
      }

             
    topicTemplate(){
       return html`
            <style>
                .launchIcon{
                    margin-top: -.3rem;
                    margin-left:.2rem;
                    width:.9rem;
                }
            </style>
            <div id='topic'>

            </div>
            



           `;
        }
    
}

customElements.define('kb-topic-infinite', KbTopicInfinite)
